import {
  Box,
  Button,
  ClickAwayListener,
  Divider,
  FormControlLabel,
  FormGroup,
  InputAdornment,
  List,
  Radio,
  TextField,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useMemo, useState } from "react";
import { useBoundStore } from "useStore";
import LightTooltip from "views/Components/Shared/Components/LightTooltip";
import SearchIcon from "@mui/icons-material/Search";
import { usePagination } from "hooks/usePagination";
import useProductMasterKamQuery from "../Queries/ProductMasterKamQuery";

function Options({ closeTooltip, kams }) {
  const selectedKams = useBoundStore((state) => state.productMasterSelectedKam);
  const setSelectedKams = useBoundStore(
    (state) => state.setProductMasterSelectedKam,
  );
  const clearStSelectedKams = useBoundStore(
    (state) => state.clearProductMasterSelectedKam,
  );

  const { paginationModel, handlePaginationChange } = usePagination();

  const [searchField, setSearchField] = useState("");

  //Filtrar los KAM según el valor del campo de búsqueda
  const filteredKams = useMemo(() => {
    return kams.filter((kam) =>
      kam.toLowerCase().includes(searchField.toLowerCase()),
    );
  }, [kams, searchField]);

  return (
    <List
      sx={{ width: "340px", maxWidth: 340, bgcolor: "background.paper" }}
      component="nav"
      aria-labelledby="nested-list-subheader"
      subheader={
        <Stack
          direction="column"
          spacing={1}
          alignItems="flex-start"
          justifyContent="space-between"
          marginBottom={2}
        >
          <Typography
            sx={{
              color: "rgba(0, 0, 0, 0.87)",
              fontFamily: "Roboto",
              fontStyle: "normal",
              fontSize: "16px",
              lineHeight: "24px",
              fontWeight: "700",
              letterSpacing: "0.15px",
              padding: "12px",
            }}
          >
            KAM:
          </Typography>
          <TextField
            value={searchField}
            onChange={(e) => setSearchField(e.target.value)}
            sx={{
              "& .MuiOutlinedInput-notchedOutline": {
                borderRadius: "5px",
                border: "1px solid #0000003B",
              },
              "& .MuiInputBase-input": {
                backgroundColor: "#FFFFFF",
              },
              "& .MuiInputBase-root": {
                backgroundColor: "#FFFFFF",
              },
              width: "100%",
              marginLeft: "8px",
              marginRight: "8px",
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
        </Stack>
      }
    >
      <Divider />

      <List component="div" disablePadding>
        <Box
          sx={{
            maxHeight: "200px",
            overflowY: "auto",
          }}
        >
          <FormGroup sx={{ pl: 2 }}>
            {filteredKams?.map((kam, index) => {
              return (
                <FormControlLabel
                  key={kam}
                  sx={{
                    borderBottom:
                      index === kams.length - 1
                        ? "none"
                        : "1px solid rgba(236, 240, 244, 1)",
                  }}
                  control={
                    <Radio
                      color="secondary"
                      checked={selectedKams.includes(kam)}
                      onChange={() => {
                        if (selectedKams.includes(kam)) {
                          clearStSelectedKams();
                        } else {
                          setSelectedKams(kam);
                        }

                        handlePaginationChange({ ...paginationModel, page: 0 });
                      }}
                    />
                  }
                  label={
                    <Typography padding={1} paddingTop={2} paddingBottom={2}>
                      {kam}
                    </Typography>
                  }
                />
              );
            })}
          </FormGroup>
        </Box>
      </List>

      <Divider />

      <Button
        color="secondary"
        onClick={closeTooltip}
        sx={{
          mt: 1,
        }}
      >
        CERRAR
      </Button>
    </List>
  );
}

export default function KamFilter() {
  const kamsQuery = useProductMasterKamQuery();
  const kams = kamsQuery?.data || [];

  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleToggleTooltip = () => {
    setOpen((prev) => !prev);
  };

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div>
        <LightTooltip
          PopperProps={{
            disablePortal: true,
          }}
          onClose={handleTooltipClose}
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={<Options closeTooltip={handleTooltipClose} kams={kams} />}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              padding: "12px",
              width: "182px",
              borderRadius: "4px",
              color: "#000000DE",
              border: "1px solid rgba(0, 0, 0, 0.23)",
              cursor: "pointer",
            }}
            onClick={handleToggleTooltip}
          >
            <Typography
              sx={{
                color: "#00000099",
                fontSize: "16px",
                fontFamily: "Roboto",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "24px",
                letterSpacing: "0.15px",
              }}
            >
              KAM
            </Typography>
            <ArrowDropDownIcon
              sx={{
                fill: "#0000008F",
                width: "24px",
                height: "24px",
              }}
            />
          </Stack>
        </LightTooltip>
      </div>
    </ClickAwayListener>
  );
}
